import React, { useEffect } from "react";
import Zuck from "myzuck.js";
import "zuck.js/css";

const Story = ({ storie }) => {
  console.log(storie, "------------------------------")
  useEffect(() => {
    // Initialize Zuck with options
    getstories()
  }, []);

  const getstories = async () => {
    if (storie != null) {
      const stories = await new Zuck("stories", storie);
    }
  }
  return (
    <div>
      <div id="stories" className="my-3" ></div>
    </div>
  );
};

export default Story;
